/**
 * Formats errors into a user-friendly message.
 */
const formatError = (err) => {
  if (err?.response?.data?.message) return err.response.data.message;
  if (err?.message) return err.message;
  return "No response received from server.";
};

export default formatError;